export default "__VITE_ASSET__C$Zr1F4U__"